module.exports = __webpack_public_path__ + "img/profile-image-inverted.1ee08af5.png";